var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateSmartServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x6erq331ta)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.928 18.184h-4.857a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4.857v-8zM25.928 5.611h-4.857a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4.857v-8zM13.572 5.611H8.713a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4.857v-8zM13.572 18.184H8.713a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4.857v-8z",
    fill: "#C9A87A",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75 17.715h-5.143a2 2 0 0 0-2 2v5.143a2 2 0 0 0 2 2h5.143a2 2 0 0 0 2-2v-5.143a2 2 0 0 0-2-2z",
    stroke: "url(#dm7mjon3mb)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75 5.143h-5.143a2 2 0 0 0-2 2v5.142a2 2 0 0 0 2 2h5.143a2 2 0 0 0 2-2V7.143a2 2 0 0 0-2-2z",
    stroke: "url(#03ugqc1irc)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.393 5.143H7.25a2 2 0 0 0-2 2v5.142a2 2 0 0 0 2 2h5.143a2 2 0 0 0 2-2V7.143a2 2 0 0 0-2-2z",
    stroke: "url(#vqggv3kdzd)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.393 17.715H7.25a2 2 0 0 0-2 2v5.143a2 2 0 0 0 2 2h5.143a2 2 0 0 0 2-2v-5.143a2 2 0 0 0-2-2z",
    stroke: "url(#5guwwr7joe)",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dm7mjon3mb",
    x1: 24.392,
    y1: 31.756,
    x2: 15.072,
    y2: 28.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "03ugqc1irc",
    x1: 24.391,
    y1: 19.183,
    x2: 15.072,
    y2: 15.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vqggv3kdzd",
    x1: 12.034,
    y1: 19.183,
    x2: 2.715,
    y2: 15.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5guwwr7joe",
    x1: 12.034,
    y1: 31.756,
    x2: 2.715,
    y2: 28.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x6erq331ta"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateSmartServices);
export default __webpack_public_path__ + "static/media/corporateSmartServices.ff8014d4f8e934efad9982c50f87e3af.svg";
export { ForwardRef as ReactComponent };